import { render, staticRenderFns } from "./KeyValueTable.vue?vue&type=template&id=7870628b&scoped=true"
import script from "./KeyValueTable.vue?vue&type=script&lang=js"
export * from "./KeyValueTable.vue?vue&type=script&lang=js"
import style0 from "./KeyValueTable.vue?vue&type=style&index=0&id=7870628b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870628b",
  null
  
)

export default component.exports